import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=2b9ab098&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ab098",
  null
  
)

export default component.exports